export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "en",
    "resource": {
      "oauth_login_fail": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["OAuth Login failed"])}
    }
  })
}
